import { axiosRef } from '.';
import { AddUserAccountDto } from '../types';

export const fetchAccountDetail = (id: any) =>
  axiosRef.get(`/sub_accounts/${id}`);

export const addSubAccount = (payload: any) =>
  axiosRef.post(`/sub_accounts`, payload);

export const editSubAccount = (payload: any) =>
  axiosRef.put(`/sub_accounts/${payload.subaccount_number}`, payload);

export const fetchBcCustomers = (payload?: any) => {
  let url = `/business_central/customers?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const fetchBcJobsList = (payload?: any) => {
  let url = `/business_central/job_list?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.isAll !== true) {
    url = url + `&is_all=${payload.isAll}&username=${payload.bc_userName}`;
  }

  return axiosRef.get(url);
};

export const fetchAdminUsers = (payload?: any) => {
  let url = `/admin/users?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.account && payload.account !== '') {
    url = url + `account=${payload.account}&`;
  }
  return axiosRef.get(url);
};

export const addUserAccount = (payload: AddUserAccountDto) =>
  axiosRef.post(`/admin/users`, payload);

export const editUserAccount = (payload: any) =>
  axiosRef.put(`/admin/users/${payload.username}`, payload);

export const getUserAccountDetail = (username: string) =>
  axiosRef.get(`/admin/users/${username}`);
